import bookingService from '@/api/booking'
import buildingService from '@/api/building'
import {BUILDING} from '@/store/types'
import utils from '@/utils/utils.js'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    rooms: null,
    locationId: ''
  },
  getters: {
    rooms (state) {
      return state.rooms
    }
  },
  mutations: {
    [BUILDING.SET_RESULT] (state, value) {
      state.rooms = value.rooms
      state.locationId = value.locationId
    },
    [BUILDING.RESET_RESULT] (state) {
      state.rooms = null
      state.locationId = null
    },
    [BUILDING.SHOW_EVENTS] (state, id) {
      state.rooms.forEach((room) => {
        if (room.id === id) {
          room.showEvents = !room.showEvents
        }
      })
    }
  },
  actions: {
    findBuilding ({commit, rootGetters, dispatch}, locationId) {
      return new Promise(resolve => {
        bookingService.findBooksByLocation(locationId).then(response => {
          let rooms = []
          if (response.data) {
            const location = rootGetters['Global/locationMap'][locationId]
            response.data.rooms.forEach(item => {
              if(utils.checkIfArrayHasFilterOptionsInterception(item.avaliableEquipmentsIds, rootGetters['Booking/equipmentSelected'])) {
                const room = rootGetters['Global/roomMap'][item.roomId]
                rooms.push({
                  id: room.id,
                  name: room.name,
                  location,
                  details: room.details,
                  equipments: room.equipments,
                  showEvents: room.showEvents,
                  capacity: room.capacity,
                  status: utils.getRoomStatus(item),
                  events: utils.getEventsWithIntervalLock(item),
                  bookable: room.bookable,
                  isCombinedRoom: room.isCombinedRoom,
                  eventsNeedApproval: room.eventsNeedApproval,
                  hasIntervalLock: item.hasIntervalLock
                })
              }
            })
          }
          commit(BUILDING.SET_RESULT, {rooms, locationId})
          resolve(rooms)
        }).catch(() => {
          resolve([])
        }).finally(()=>{
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    reset (store) {
      store.commit(BUILDING.RESET_RESULT)
    },
    quickEvent ({ rootGetters}, data) {
      let event = {
        startDate: Vue.prototype.$moment().second(0).format(),
        endDate: data.quickTime.second(0).format(),
        rooms: [data.room.id],
        email: rootGetters['Auth/userEmail'],
        title: data.title,
        isPrivateEvent: false,
        attendees: [],
        recurrence: 'none',
        timeZone: Vue.prototype.$moment.tz.guess()
      }
      return bookingService.save(event)
    },
    sendMail ({state}, data) {
      return buildingService.sendMail(state.locationId, data.room.id, data.event.eventId)
    },
    showEvents ({commit}, id) {
      commit('SHOW_EVENTS', id)
    }
  }
}
